import { AUTHENTICATED_ROUTES, AUTHENTICATED_ROUTES_STARTS_WITH } from '@/configs/constants';

const authenticatedRoutesStartsWithRegex = new RegExp(
  `^(${AUTHENTICATED_ROUTES_STARTS_WITH.join('|')})`,
);

const isAuthenticatedRoute = (pathname: string) => {
  return (
    authenticatedRoutesStartsWithRegex.test(pathname) || AUTHENTICATED_ROUTES.includes(pathname)
  );
};

export default isAuthenticatedRoute;
